import { useContext } from 'react';
import { StatsigContext } from './statsig-context';

export const useStatsigContext = () => {
  return useContext(StatsigContext);
};
